__turbopack_context__.v({
  "aurora-shimmer": "FeedSkeleton-module-scss-module__E983Iq__aurora-shimmer",
  "skeleton": "FeedSkeleton-module-scss-module__E983Iq__skeleton",
});
